exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-props-list[data-v-6fd35537]{width:300px;height:240px;overflow-x:hidden;overflow-y:auto;border:1px solid #dcdfe6;border-radius:4px;margin:0 auto}.selected-props-list ul[data-v-6fd35537]{padding:5px;margin:0;list-style:none}.selected-props-list li[data-v-6fd35537]{list-style:none;padding:0 10px;margin:4px 0;cursor:pointer;line-height:24px}.selected-props-list li b[data-v-6fd35537]{font-weight:400}.selected-props-list li.active[data-v-6fd35537]{background:#3a8ee6;color:#fff}.selected-props-list p[data-v-6fd35537]{text-align:center;margin:15px auto}.selected-props-list .col-input-item[data-v-6fd35537]{background:#fff}", ""]);

// exports
